import React from 'react';
import { Link } from 'react-router-dom';
import { BundeslandInfo } from '../../types/einwohnermeldeamt';
import { formatNumber } from '../../utils/einwohnermeldeamtHelpers';

interface BundeslandCardProps {
  bundesland: BundeslandInfo;
}

const BundeslandCard: React.FC<BundeslandCardProps> = ({ bundesland }) => {
  return (
    <Link
      to={`/einwohnermeldeamt/${bundesland.slug}`}
      className="block bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-200 group"
    >
      <div className="flex items-start justify-between mb-4">
        <h3 className="text-xl font-bold group-hover:text-celestial-blue transition-colors" style={{ color: '#023047' }}>
          {bundesland.name}
        </h3>
        <svg
          className="w-6 h-6 text-gray-400 group-hover:translate-x-1 transition-transform"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>
      </div>
      
      <div className="space-y-2 text-gray-600">
        <div className="flex items-center gap-2">
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
          </svg>
          <span>{formatNumber(bundesland.locationCount)} Einwohnermeldeämter</span>
        </div>
        
        <div className="flex items-center gap-2">
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
            <path d="M9 6a3 3 0 11-6 0 3 3 0 016 0zM17 6a3 3 0 11-6 0 3 3 0 016 0zM12.93 17c.046-.327.07-.66.07-1a6.97 6.97 0 00-1.5-4.33A5 5 0 0119 16v1h-6.07zM6 11a5 5 0 015 5v1H1v-1a5 5 0 015-5z" />
          </svg>
          <span>ca. {formatNumber(bundesland.totalPopulation)} Einwohner</span>
        </div>
      </div>
      
      <div className="mt-4 pt-4 border-t border-gray-200">
        <span className="text-sm font-medium group-hover:text-celestial-blue transition-colors" style={{ color: '#219ebc' }}>
          Alle Meldeämter anzeigen →
        </span>
      </div>
    </Link>
  );
};

export default BundeslandCard;

